import { useCallback } from 'react'
import { StatusOfflineIcon, StatusOnlineIcon } from '@heroicons/react/solid'
import { toast } from 'react-toastify'

import { toggle } from '../../services/api'

interface Props {
  productId: number | string
  isActive: boolean
  onToggle?: (id: number, isActive: boolean) => void
}

export function ToggleActivation({
  productId,
  isActive,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onToggle = () => {}
}: Props) {
  const doToggle = useCallback(async () => {
    try {
      const { id, attributes } = await toggle(productId, isActive)
      toast.success(
        isActive
          ? 'Produto desativado com sucesso'
          : 'Produto ativado com sucesso'
      )
      onToggle(id, attributes.active ?? !isActive)
    } catch (err: any) {
      toast.error(err.suggestedMessage ?? 'Não foi possível alterar o produto')
    }
  }, [productId, isActive, onToggle])

  return (
    <>
      {isActive ? (
        <button
          onClick={doToggle}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
        >
          <StatusOfflineIcon
            className="h-5 w-5 text-red-500"
            aria-hidden="true"
          />
          Desativar
        </button>
      ) : (
        <button
          onClick={doToggle}
          className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
        >
          <StatusOnlineIcon
            className="h-5 w-5 text-emerald-600"
            aria-hidden="true"
          />
          Ativar
        </button>
      )}
    </>
  )
}
